import { useMutation } from '@tanstack/react-query';

import { AllowListFormSchemaValues } from 'src/features/allowList/utils/formSchema';
import { AllowList } from 'src/features/allowList/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/allow-lists/allow-list/';

interface DTO {
    parkingId: string;
    data: AllowListFormSchemaValues;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, data }: DTO): Promise<AllowList> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId}), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateAllowList };
